// Local cache availability.
//
// Storage is IndexedDB (see idb.js) — the SQLite plugin had to go because its
// prebuilt libsqlcipher.so is compiled for 4 KB memory pages and Google Play now
// requires 16 KB alignment. A prebuilt binary cannot be realigned by build
// settings, so the choice was a native rewrite or no native library at all.
//
// The store layout, the sync logic and the read API are unchanged, so this swap
// is invisible above core/db.
//
// MOBILE ONLY, still. IndexedDB would work in a desktop browser too, but the
// desktop shell is a live dashboard against the server and giving it a
// silently-stale offline copy would be a behaviour change nobody asked for.

import { openDb, STORE_NAMES } from './idb';
import { isNativePlatform } from '../platform';

export { STORE_NAMES as SYNC_TABLES };

export function dbSupported() {
  return isNativePlatform() && typeof indexedDB !== 'undefined';
}

// Kept for callers that used to open a SQLite connection. Returns null when the
// cache is unavailable so they fall back to REST, exactly as before.
export async function getDb() {
  if (!dbSupported()) return null;
  try {
    return await openDb();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[DB] open failed, falling back to REST:', (e && e.message) || e);
    return null;
  }
}

export async function closeDb() {
  // IndexedDB connections do not need explicit teardown; the browser closes them
  // with the page. Left as a no-op so callers keep working.
}
